import type { ComponentType, ReactNode } from 'react';
import type { LucideIcon } from 'lucide-react';

// one menu entry; the admin app's navigation list is made of these and drives menu, routes and breadcrumbs
export type NavItem = {
  label: string;
  path: string;
  icon: LucideIcon;
  permission?: string;
  description?: string;
  // pages under a group are gathered under a heading (Game content: "The city", "Home life"…)
  group?: string;
};
// a top-level entry: a page of its own and, under it, the pages the menu shows when the group is open (and the
// group's own page lists as cards when it has nothing else to show)
export type NavGroup = NavItem & { children?: NavItem[] };

// the router's link (react-router's NavLink) is passed in, so the shared UI does not depend on a router
export type NavLinkComponent = ComponentType<{
  to: string;
  end?: boolean;
  className?: string | ((state: { isActive: boolean }) => string);
  onClick?: () => void;
  title?: string;
  children?: ReactNode;
}>;

export type Can = (permission: string) => boolean;
export const allowed = (item: NavItem, can: Can) => !item.permission || can(item.permission);
// the pages under a group the admin may open
export const allowedChildren = (group: NavGroup, can: Can) =>
  (group.children ?? []).filter((item) => allowed(item, can));
// where a group opens: its own page, or the first page under it the admin may see; nowhere (so not in the
// menu) when the admin may see none of its pages
export function groupHome(group: NavGroup, can: Can): string | null {
  const children = allowedChildren(group, can);
  if (group.children?.length && !children.length) return null;
  return allowed(group, can) ? group.path : (children[0]?.path ?? null);
}
